<div class="page-content">
  <header class="page_header">
    <div class="page_header_text">
      <h1>Configurações da Aplicação</h1>
      <span>Identidade do tenant e funcionalidades disponíveis por cliente.</span>
    </div>
    <div class="page_header_actions">
      <button
        type="button"
        class="btn-secondary"
        [disabled]="loading() || saving() || !form.dirty"
        (click)="restore()"
      >
        <i class="fas fa-rotate-left"></i> Descartar
      </button>
      <button
        type="button"
        class="btn-primary"
        [disabled]="loading() || loadFailed() || saving() || form.pristine"
        (click)="save()"
      >
        <i class="fas" [class.fa-save]="!saving()" [class.fa-spinner]="saving()" [class.fa-spin]="saving()"></i>
        {{ saving() ? 'A guardar…' : 'Guardar alterações' }}
      </button>
    </div>
  </header>

  @if (loading()) {
    <section class="state-card" aria-live="polite">
      <i class="fas fa-spinner fa-spin"></i>
      <strong>A carregar configurações</strong>
      <span>A obter os dados do tenant no servidor.</span>
    </section>
  } @else if (loadFailed()) {
    <section class="state-card error-state" role="alert">
      <i class="fas fa-triangle-exclamation"></i>
      <strong>Não foi possível carregar as configurações</strong>
      <span>Verifique a ligação e tente novamente.</span>
      <button type="button" class="btn-secondary" (click)="loadConfiguration()">
        <i class="fas fa-rotate-right"></i> Tentar novamente
      </button>
    </section>
  } @else {
    <form [formGroup]="form" (ngSubmit)="save()">
      <nav class="tabs-nav" role="tablist">
        <button
          type="button"
          role="tab"
          class="tab-btn"
          [class.active]="activeTab() === 'identidade'"
          (click)="setActiveTab('identidade')"
        >
          <i class="fas fa-id-card"></i>
          <span>Identidade</span>
        </button>

        <button
          type="button"
          role="tab"
          class="tab-btn"
          [class.active]="activeTab() === 'funcionalidade'"
          (click)="setActiveTab('funcionalidade')"
        >
          <i class="fas fa-sliders"></i>
          <span>Funcionalidades</span>
          <span class="tab-badge">{{ enabledReportsCount() }}</span>
        </button>
      </nav>

      <div class="tabs-content">
        @if (activeTab() === 'identidade') {
          <div class="tab-panel">
            <app-tenant-identity-tab
              [form]="form"
              [logoPreview]="logoPreview"
              [disabled]="saving()"
              (logoChange)="onLogoChange($event)"
              (validationError)="showError($event)"
            />
          </div>
        } @else if (activeTab() === 'funcionalidade') {
          <div class="tab-panel">
            <app-report-selection-tab
              [control]="form.controls.enabledReportIds"
              [options]="reportOptions"
              [disabled]="saving()"
            />
          </div>
        }
      </div>
    </form>
  }

  <div class="save-bar" [class.visible]="form.dirty && !loading() && !loadFailed()">
    <span>
      <i class="fas fa-circle-info"></i>
      Existem alterações por guardar.
    </span>

    <button type="button" class="btn-primary" [disabled]="saving()" (click)="save()">
      <i class="fas" [class.fa-save]="!saving()" [class.fa-spinner]="saving()" [class.fa-spin]="saving()"></i>
      {{ saving() ? 'A guardar…' : 'Guardar' }}
    </button>
  </div>
</div>